module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-10.737a2125.png";